// extracted by mini-css-extract-plugin
export default {"value":"DatePickerInput_value__RD4QG","input":"DatePickerInput_input__yB9DY"};